<template>
  <div class="onboarding-static-page-container">
      <OnboardingMenu class="menu" :logo="logoUrl" :languages="languageOptions" :menus="menuOptions"></OnboardingMenu>
      <div class="header">
        <p class="title">{{ $t('onboarding.nestle.learningPage.learning') }}</p>
      </div>
      <div class="body">
        <div class="description">
            <p>{{ $t('onboarding.nestle.learningPage.introduction') }}</p>
            <div class="dividing-line"></div>
        </div>
        <div class="video-board">
          <div class="board-body">
            <div class="board-video">
              <div v-show="showVideoImage" class="board-video-preview-image" @click="playVideo()">
                <img :src="previewImgUrl" alt="">
                <img :src="playIcon" class="board-video-play-icon">
              </div>
              <video ref="video" v-show="!showVideoImage" controls>
                <source src="https://static-c.ajinga.com/nestle/GLO_History.mp4" type="video/mp4" />
              </video>
            </div>
            <div class="board-content">
              <p class="board-title">{{ $t('onboarding.nestle.learningPage.ourHistory') }}</p>
              <p class="board-description">{{ $t('onboarding.nestle.learningPage.ourHistoryDescription') }}</p>
            </div>
          </div>
        </div>
        <!-- <div class="image-board clear-margin-top" @click="toOutSide('/vue-static/purpose-and-values/story.html')"> -->
        <div class="image-board clear-margin-top">
            <img :src="purposeValuesImgUrl" alt="">
            <div class="content">
              <p class="board-title">{{ $t('onboarding.nestle.learningPage.ourPurpose') }}</p>
              <p class="board-subtitle">{{ $t('onboarding.nestle.learningPage.ourPurposeDescription') }}</p>
            </div>
        </div>
        <!-- <div class="image-board flex-derection-row-reverse" @click="toOutSide('/vue-static/work-environment/desktop.html')"> -->
        <div class="image-board flex-derection-row-reverse">
            <img :src="workEnvironmentImgUrl" alt="">
            <div class="content">
              <p class="board-title">{{ $t('onboarding.nestle.learningPage.ourEnvironment') }}</p>
              <p class="board-subtitle">{{ $t('onboarding.nestle.learningPage.ourEnvironmentDescription') }}</p>
            </div>
        </div>
        <div class="follow">
          <p v-html="$t('onboarding.nestle.followUs')"></p>
          <p>{{ $t('onboarding.nestle.donnotBeShared') }}</p>
        </div>
      </div>
      <Footer></Footer>
  </div>
</template>

<script>
import { onboardingMixin } from '@/components/onboarding/form/mixin.js'
import OnboardingMenu from '@/components/onboarding/form/Menu'
import Footer from '@/components/onboarding/form/Footer'
import { deviceType } from '@/utils/common'

export default {
  mixins: [onboardingMixin],
  components: {
    OnboardingMenu, Footer
  },
  data () {
    const isMobile = deviceType.isMobile
    return {
      previewImgUrl: require(isMobile ? '@/assets/image/onboarding/learning/h5/video.jpg' : '@/assets/image/onboarding/learning/pc/video.jpg'),
      purposeValuesImgUrl: require(isMobile ? '@/assets/image/onboarding/learning/h5/purpose.jpg' : '@/assets/image/onboarding/learning/pc/purpose.jpg'),
      workEnvironmentImgUrl: require(isMobile ? '@/assets/image/onboarding/learning/h5/environment.jpg' : '@/assets/image/onboarding/learning/pc/environment.jpg'),
      showWelcome: false,
      showVideoImage: true,
      playIcon: require('@/assets/iconfont/icon-play.svg')

    }
  },
  created () {

  },
  methods: {
    playVideo (index) {
      if (index !== undefined) {
        this.customVideosAndImg.customVideos[index].showVideoImage = false
        this.$refs.customVideos[index].play()
      } else {
        this.showVideoImage = false
        this.$refs.video.play()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/onboarding-common.scss';
@import '@/assets/scss/onboarding-static-page.scss';

.onboarding-static-page-container {
  .header {
    background-image: url('~@/assets/image/onboarding/learning/h5/banner.jpg');
  }
}

/* 中型设备（台式电脑） */
@media (min-width: 769px) {
  .onboarding-static-page-container {
    .header {
      background-image: url('~@/assets/image/onboarding/learning/pc/banner.jpg');
    }
  }
}
</style>
